<template>
  <div class="form-item">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px" label-position="left">
      <el-form-item :label="$t('microSite.form.label.itemType')" prop="type">
        <el-select
          class="item-type-select"
          v-model="form.type"
          :placeholder="$t('microSite.form.placeholder.itemType')"
          :disabled="isEdit"
          @change="handelTypeChange"
        >
          <el-option
            v-for="(item, index) in typeList"
            :key="index"
            :label="$t(item.i18nKey)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('microSite.form.label.isRequired')" prop="isRequired">
        <SwitchButton v-model="form.isRequired" :options="options"></SwitchButton>
      </el-form-item>
      <el-form-item :label="$t('microSite.common.form.title')" prop="title">
        <el-input v-model="form.title" :placeholder="$t('microSite.common.form.titlePlaceholder')">
        </el-input>
      </el-form-item>
      <el-form-item v-if="showOption" :label="$t('microSite.form.label.option')" prop="options">
        <el-input
          v-model="form.options"
          :placeholder="$t('microSite.form.placeholder.option')"
          type="textarea"
          :autosize="{ minRows: 5}"
        >
        </el-input>
      </el-form-item>
      <el-form-item v-if="showLinkContainer" :label="$t('microSite.form.label.link')" prop="linkSetting">
        <div class="link-tip-container">
          <SwitchButton v-model="form.linkSetting.isUpload" :options="linkOptions" @change="handelLinkTypeChange"></SwitchButton>
        </div>
        <template v-if="!form.linkSetting.isUpload" >
          <el-input v-model="form.linkSetting.url" :placeholder="$t('microSite.form.placeholder.link')"/>
        </template>
        <template v-else>
          <FileUpload v-model="form.linkSetting.upload"/>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import editorTemplate from '../../editorTemplate'
import { FORM_ITEM_TYPE_LIST, HAS_OPTION_FORM_ITEM_TYPE } from '@/constant/crm'
import SwitchButton from '../../../components/editor/switchButton.vue'
import FileUpload from '../../../components/editor/fileUpload.vue'

export default {
  components: {
    SwitchButton,
    FileUpload
  },
  mixins: [editorTemplate],
  data () {
    return {
      typeList: FORM_ITEM_TYPE_LIST,
      isEdit: false,
      form: {
        itemKey: null,
        title: null,
        type: null,
        isRequired: true,
        options: null,
        linkSetting: {
          isUpload: false,
          url: '',
          upload: {
            fileName: '',
            fileUrl: '',
            fileKey: ''
          }
        }
      },
      linkOptions: [
        {
          label: this.$t('microSite.form.label.url'),
          value: false
        },
        {
          label: this.$t('microSite.form.label.attachment'),
          value: true
        }
      ],
      options: [
        {
          label: this.$t('microSite.common.form.no'),
          value: false
        },
        {
          label: this.$t('microSite.common.form.yes'),
          value: true
        }
      ]
    }
  },
  computed: {
    itemKey () {
      let formKey = this.renderData.parent?.data?.props?.formKey
      if (!formKey) {
        const parentId = this.renderData.parent?.id
        formKey = `crm_${parentId}`
      }
      if (formKey) {
        return `${formKey}_item_${this.renderData.id}`
      }
      return ''
    },
    showOption () {
      if (HAS_OPTION_FORM_ITEM_TYPE.includes(this.form.type)) {
        return true
      }
      return false
    },
    showLinkContainer () {
      return this.form.type === FORM_ITEM_TYPE_LIST.LINK.value
    },
    rules () {
      // const checkLink = (rule, linkSetting, callback) => {
      //   if ((linkSetting.isUpload && !linkSetting.upload?.fileUrl) || (!linkSetting.isUpload && !linkSetting.url)) {
      //     return callback(this.$t('microSite.form.message.linkRequired'))
      //   }
      //   callback()
      // }
      return {
        type: [
          { required: true, trigger: 'blur' }
        ],
        isRequired: [
          { required: true, trigger: 'blur' }
        ],
        title: [
          { required: true, message: this.$t('microSite.form.message.isRequired'), trigger: 'blur' }
        ],
        options: [
          { required: true, message: this.$t('microSite.form.message.optionRequired'), trigger: 'blur' }
        ]
        // ,
        // linkSetting: [
        //   { validator: checkLink, trigger: 'blur' }
        // ]
      }
    }
  },
  created () {
    const props = this.renderData.data.props
    this.form.title = props.title
    this.form.type = props.type || FORM_ITEM_TYPE_LIST.TEXT.value
    this.form.isRequired = props.isRequired
    this.form.options = props.options
    if (props.linkSetting) {
      this.form.linkSetting = props.linkSetting
    }
    if (props.title) {
      this.isEdit = true
    }
  },
  methods: {
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.title
      props.type = this.form.type
      props.isRequired = this.form.isRequired
      props.options = this.form.options
      props.linkSetting = this.form.linkSetting
      props.itemKey = this.form.itemKey || this.itemKey
      this.updateConfigInRoot()
      return true
    },
    handelTypeChange () {
      this.$refs.form.clearValidate()
    },
    handelLinkTypeChange () {
      this.$refs.form.clearValidate()
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  .item-type-select {
    width: 100%;
  }
  .link-tip-container {
    margin-bottom: 22px;

    .link-tip-label {
      margin-right: 30px;
    }
  }
}
</style>
